import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import api from '../api';

function Login({ setUser }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (token) {
      setLoading(true);
      api.get('/auth/verify', {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        localStorage.setItem('token', res.data.token);
        setUser(res.data);
        history.push('/profil');
      })
      .catch(() => {
        setMessage('Ungültiger oder abgelaufener Link');
        setLoading(false);
      });
    }
  }, [location, history, setUser]);

  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
    }

    if (!email || loading) return;

    setLoading(true);
    setMessage('');

    try {
      const response = await api.post('/auth/request-login', { email });
      setMessage(response.data.message);
      setEmail('');
    } catch (error) {
      setMessage('Fehler beim Senden des Login-Links');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card" style={{ maxWidth: '500px', margin: '2rem auto' }}>
      <h2>Anmelden</h2>
      <p style={{ marginBottom: '1.5rem', color: '#666' }}>
        Geben Sie Ihre E-Mail-Adresse ein. Sie erhalten einen Login-Link per E-Mail.
      </p>

      <form onSubmit={handleSubmit}>
        <label>E-Mail-Adresse</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="ihre.email@beispiel.de"
          required
          disabled={loading}
        />

        <button
          type="submit"
          className="btn"
          disabled={loading}
          onClick={(e) => {
            // Fallback for mobile browsers where form submit might not work
            if (!loading && email) {
              handleSubmit(e);
            }
          }}
          style={{ width: '100%' }}
        >
          {loading ? 'Wird gesendet...' : 'Login-Link anfordern'}
        </button>
      </form>

      {message && (
        <div style={{
          marginTop: '1rem',
          padding: '0.75rem',
          borderRadius: '4px',
          backgroundColor: message.includes('Fehler') ? '#ffebee' : '#e8f5e9',
          color: message.includes('Fehler') ? '#c62828' : '#2e7d32'
        }}>
          {message}
        </div>
      )}
    </div>
  );
}

export default Login;
